/* Aravi - add to cart confetti
 *
 * A short burst of confetti around whichever Add to cart button was pressed,
 * on the home page, collection pages and the product page alike.
 *
 * Timing: the burst starts on the click itself, before the request to
 * /cart/add is even sent, and is gone in half a second. The cart drawer opens
 * when that request comes back, which is later, so the confetti has cleared
 * by then. It also clears itself the moment the drawer actually opens, in
 * case the response is unusually quick.
 *
 * It only listens. It never calls preventDefault, never touches the form and
 * never blocks the click, so if anything in here throws, adding to cart still
 * works exactly as before.
 */
(function () {
  if (window.araviConfettiLoaded) { return; }
  window.araviConfettiLoaded = true;

  var LIFE = 500;
  var COLORS = ['#00a778', '#27cf7b', '#f5b300', '#fb4a4c', '#8b6be0', '#3293d2'];

  /* Halo puts data-btn-addToCart on real add-to-cart buttons in product cards
     and quick shop; the CRO product section uses .acro-atc__btn; a plain
     Shopify product form submits through name="add". Links are deliberately
     not matched - "Select options" and "Notify me" navigate, they do not add. */
  var SELECTOR = [
    '.acro-atc__btn',
    'button[name="add"]',
    'input[type="submit"][name="add"]',
    'button[data-btn-addToCart]'
  ].join(',');

  var styleAdded = false;
  function addStyle() {
    if (styleAdded) { return; }
    styleAdded = true;
    var css =
      '.aravi-cft{position:fixed;left:0;top:0;width:0;height:0;pointer-events:none;' +
      'z-index:2147482000;}' +
      '.aravi-cft i{position:absolute;width:7px;height:7px;border-radius:1px;display:block;' +
      'will-change:transform,opacity;' +
      'animation:aravi-cft-fly ' + LIFE + 'ms cubic-bezier(.16,.84,.44,1) forwards;}' +
      '@keyframes aravi-cft-fly{' +
      '0%{transform:translate(-50%,-50%) scale(.35) rotate(0deg);opacity:1;}' +
      '65%{opacity:1;}' +
      '100%{transform:translate(calc(-50% + var(--dx)),calc(-50% + var(--dy)))' +
      ' scale(.9) rotate(var(--rot));opacity:0;}}' +
      '@media (prefers-reduced-motion:reduce){.aravi-cft{display:none;}}';
    var tag = document.createElement('style');
    tag.appendChild(document.createTextNode(css));
    document.head.appendChild(tag);
  }

  var live = null;
  var timer = null;

  function clear() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (live && live.parentNode) { live.parentNode.removeChild(live); }
    live = null;
  }

  function burst(btn) {
    addStyle();
    clear();

    var box = btn.getBoundingClientRect();
    var cx = box.left + box.width / 2;
    var cy = box.top + box.height / 2;

    var wrap = document.createElement('div');
    wrap.className = 'aravi-cft';
    wrap.setAttribute('aria-hidden', 'true');

    var count = 16;
    for (var i = 0; i < count; i++) {
      var angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.4;
      var reach = 40 + Math.random() * 48;
      var bit = document.createElement('i');
      bit.style.left = cx + 'px';
      bit.style.top = cy + 'px';
      bit.style.background = COLORS[i % COLORS.length];
      bit.style.setProperty('--dx', (Math.cos(angle) * reach).toFixed(1) + 'px');
      bit.style.setProperty('--dy', (Math.sin(angle) * reach).toFixed(1) + 'px');
      bit.style.setProperty('--rot', Math.round(Math.random() * 540 - 270) + 'deg');
      bit.style.animationDelay = Math.round(Math.random() * 40) + 'ms';
      wrap.appendChild(bit);
    }

    document.body.appendChild(wrap);
    live = wrap;
    timer = setTimeout(clear, LIFE + 60);
  }

  document.addEventListener('click', function (e) {
    try {
      var el = e.target;
      if (!el || !el.closest) { return; }
      var btn = el.closest(SELECTOR);
      if (!btn) { return; }
      if (btn.disabled) { return; }
      if (btn.getAttribute('aria-disabled') === 'true') { return; }
      burst(btn);
    } catch (err) {}
  }, true);

  /* Halo toggles a class on <body> when a drawer opens. If the cart drawer
     beats the timer, drop the confetti straight away so it is never drawn
     over the open drawer. */
  if (window.MutationObserver && document.body) {
    new MutationObserver(function () {
      if (!live) { return; }
      if (/cart/i.test(document.body.className)) { clear(); }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
